// src/components/admin/AdminUserVerification.jsx
import React, { useEffect, useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, orderBy, query } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig"; // adjust import if your path differs

export default function AdminUserVerification() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(null);
  const [error, setError] = useState("");

  const functions = getFunctions(undefined, "europe-west2");
  const sendVerifyEmail = httpsCallable(functions, "sendCustomVerifyEmail");

  // load users from Firestore `/users` collection
  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, "users"), orderBy("email"));
        const snap = await getDocs(q);
        const list = snap.docs.map((doc) => ({
          uid: doc.id,
          ...doc.data(),
        }));
        setUsers(list);
      } catch (err) {
        console.error(err);
        setError("Failed to load users");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const handleSendVerify = async (email) => {
    if (!email) return;
    if (!window.confirm(`Send verification email to ${email}?`)) return;
    setSending(email);
    try {
      await sendVerifyEmail({ email });
      alert(`Verification email sent to ${email}`);
    } catch (err) {
      console.error("sendVerifyEmail failed:", err);
      alert("Failed to send verification email.");
    } finally {
      setSending(null);
    }
  };

  if (loading) return <p className="p-4 text-gray-500">Loading users…</p>;
  if (error) return <p className="p-4 text-red-500">{error}</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4 text-gray-800">
        User Email Verification
      </h2>

      <table className="w-full border-collapse text-sm">
        <thead>
          <tr className="bg-gray-200 text-left">
            <th className="p-2 border">Name</th>
            <th className="p-2 border">Email</th>
            <th className="p-2 border text-center">Verified</th>
            <th className="p-2 border text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u) => (
            <tr key={u.uid} className="hover:bg-gray-50">
              <td className="p-2 border">{u.name || "—"}</td>
              <td className="p-2 border">{u.email}</td>
              <td className="p-2 border text-center">
                {u.emailVerified ? (
                  <span className="text-green-600 font-medium">✔ Verified</span>
                ) : (
                  <span className="text-red-500">✖ Not Verified</span>
                )}
              </td>
              <td className="p-2 border text-center">
                {u.emailVerified ? (
                  <span className="text-gray-400">—</span>
                ) : (
                  <button
                    onClick={() => handleSendVerify(u.email)}
                    disabled={sending === u.email}
                    className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 disabled:opacity-50"
                  >
                    {sending === u.email ? "Sending…" : "Send Email"}
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
